import { render, staticRenderFns } from "./OrderSalesman.vue?vue&type=template&id=694a4772&scoped=true"
import script from "./OrderSalesman.vue?vue&type=script&lang=js"
export * from "./OrderSalesman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694a4772",
  null
  
)

export default component.exports